import React, {Component} from 'react'

import DefaultPage from './DefaultPage'

import {MessageBanner} from '@amzn/stencil-react-components/message-banner'

class MessageBannerPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {message} = this.props;

    return (
      <DefaultPage>
        <MessageBanner type={message.type}>
          {message.value}
        </MessageBanner>
      </DefaultPage>
    );
  }
}

export default MessageBannerPage;
